export const DIMENSION = {
  Desktop: 'desktop',
  Tablet: 'tablet',
  Mobile: 'mobile',
};

export const LAYOUT = {
  Fluid: 'fluid',
  Boxed: 'boxed',
};

export const RADIUS = {
  Rounded: 'rounded',
  Standard: 'standard',
  Flat: 'flat',
};

export const THEME_COLOR = {
  LightBlue: 'light-blue',
  DarkBlue: 'dark-blue',
  LightRed: 'light-red',
  DarkRed: 'dark-red',
  LightGreen: 'light-green',
  DarkGreen: 'dark-green',
  LightPurple: 'light-purple',
  DarkPurple: 'dark-purple',
  LightPink: 'light-pink',
  DarkPink: 'dark-pink',
};

export const NAV_COLOR = {
  Default: 'default',
  Light: 'light',
  Dark: 'dark',
};
export const MENU_PLACEMENT = {
  Vertical: 'vertical',
  Horizontal: 'horizontal',
};
export const MENU_BEHAVIOUR = {
  Pinned: 'pinned',
  Unpinned: 'unpinned',
};

export const USER_ROLE = {
  Admin: 'superAdmin',
  Editor: 'editor',
};

// Local backend (default): set REACT_APP_API_URL in .env to override (e.g. remote staging).
// Example: REACT_APP_API_URL=http://localhost:8380/api/v1/
// export const apiUrl =
//   (typeof process !== 'undefined' && process.env.REACT_APP_API_URL) ||
//   `http://localhost:8380/api/v1/`;

// export const apiUrl = `http://localhost:8380/api/v1/`;
export const apiUrl = `https://omc.live.backend.teceads.co.in/api/v1/`;

// Remote examples (uncomment and set REACT_APP_API_URL instead):
// `https://omc.live.backend.teceads.co.in/api/v1/`
// `https://be.omc.recruitment.teceads.co.in/api/v1/`
// export const staticFileUrl = `http://localhost:8005/`;

export const apiSecret = `registeruser`;

export const getToken = async () => {
  let token = await sessionStorage.getItem('data');
  token = token ? JSON.parse(token).token : '';
  return `${token}`;
};

export const getRole = async () => {
  let role = await sessionStorage.getItem('data');
  role = role ? JSON.parse(role).role : '';
  return `${role}`;
};

export const getBasicUserDetails = async () => {
  let data = await sessionStorage.getItem('data');
  data = data ? JSON.parse(data) : {};
  console.log(data, 'data1');

  let userBasicDetails = {};
  if (data && data !== '' && Object.keys(data).length > 0) {
    userBasicDetails = data.userBasicDetails;
    console.log(userBasicDetails, 'data2');
  }
  return userBasicDetails;
};
